import { render, staticRenderFns } from "./ArticleShowView.vue?vue&type=template&id=ed45f08c&scoped=true&"
import script from "./ArticleShowView.vue?vue&type=script&lang=js&"
export * from "./ArticleShowView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleShowView.vue?vue&type=style&index=0&id=ed45f08c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed45f08c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
